import Api from '@utils/api';
import { Archivos } from '@constants/urls';

export const state = {
	archivos: [],
	archivo: {},
	csv: {},
	filtro: '',
	loading: false,
	loading_action: false
};

export const getters = {
	getArchivos(state) {
		return state.archivos;
	},
	getArchivo(state) {
		return state.archivo;
	},
	getCSV(state) {
		return state.csv;
	},
	getLoading(state) {
		return state.loading;
	},
	getLoadingAction(state) {
		return state.loading_action;
	}
};

export const mutations = {
	SET_ARCHIVOS(state, newValue) {
		state.archivos = newValue;
	},
	SET_ARCHIVO(state, newValue) {
		state.archivo = newValue;
	},
	SET_CSV(state, newValue) {
		state.csv = newValue;
	},
	SET_LOADING_FILES(state, newValue) {
		state.loading_action = newValue;
	},
	SET_FILTRO(state, newValue) {
		state.filtro = newValue;
	},
	SET_LOADING(state, newValue) {
		state.loading = newValue;
	}
};

export const actions = {
	inicializar({ commit }) {
		commit('SET_LOADING', true);
		Api.Get(Archivos.LISTAR)
			.then((response) => {
				commit('SET_ARCHIVOS', response.data.data);
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	limpiar({ commit }) {
		commit('SET_ARCHIVOS', []);
	},
	establecerArchivos({ commit }, archivo) {
		commit('SET_ARCHIVO', archivo);
	},
	establecerFiltro({ commit }, { filtro }) {
		commit('SET_FILTRO', filtro);
	},
	descargarCSV({ commit }, { csv, onComplete }) {
		Api.PostBlob(Archivos.POST, csv).then((response) => {
			commit('SET_CSV', response.data);
			onComplete();
		});
	}
};
